import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '吉利请你看电影';
const baseUrl = '20210209JiLiMoive';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      name: `${baseUrl}-rules`,
      component: () => import('./pages/Rules.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'apply',
      name: `${baseUrl}-apply`,
      component: () => import('./pages/Apply.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'success-apply',
      name: `${baseUrl}-success-apply`,
      component: () => import('./pages/SuccessSubmit.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'convert',
      name: `${baseUrl}-convert`,
      component: () => import('./pages/UserInfo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
